<div class="flex-center py-6">
  <div class="narrow-card-container">
    <div class="card">
      <div class="card-body p-4 p-sm-5">
        @if (parsed.kind === 'invalid') {
        <div class="row flex-between-center mb-2">
          <div class="col-auto">
            <h5>{{ "twoFactorAuth.authentication" | translate }}</h5>
          </div>
        </div>
        <div class="notification">
          <span class="icon bi-info-circle me-2"></span>
          <span class="text my-a">{{
            "twoFactorAuth.missingNavigationState" | translate
          }}</span>
        </div>
        <div class="mb-3">
          <a class="btn btn-primary d-block w-100 mt-3" href="#/auth/login">{{
            "general.logIn" | translate
          }}</a>
        </div>
        } @else {
        <div class="row flex-between-center mb-2">
          <div class="col-auto">
            @if (parsed.kind === 'passwordReset') {
            <h5>{{ "general.forgottenPassword" | translate }}</h5>
            } @else {
            <h5>{{ "twoFactorAuth.authentication" | translate }}</h5>
            }
          </div>
        </div>
        <div class="notification">
          <span class="icon bi-info-circle me-2"></span>
          <span class="text my-a">{{
            (parsed.kind === "passwordReset"
              ? "forgottenPasswordChange.twoFactorPrompt"
              : "twoFactorAuth.copyAuthCode"
            ) | translate
          }}</span>
        </div>
        <form [formGroup]="formGroup" (submit)="onSubmit()">
          <div class="mb-3">
            <app-validated-input
              label="twoFactorAuth.authCode"
              inputFormControlName="code"
              [inputFormControl]="formGroup.controls.code"
              [validationTrainslations]="{
                required: 'validation.required',
                invalidTwoFactorCode: 'validation.invalidTwoFactorCode',
              }"
            />
          </div>
          <div class="row flex-between-center">
            <div class="col-auto">
              <div class="form-check mb-0"></div>
            </div>
            @if (parsed.kind === 'login') {
            <div class="col-auto">
              <a class="fs-10" href="#/auth/forgot-password">{{
                "twoFactorAuth.resendCode" | translate
              }}</a>
            </div>
            }
          </div>
          @if (errorMessage) {
          <div class="text-danger small mb-2">{{ errorMessage }}</div>
          }
          <div class="mb-3">
            <button
              class="btn btn-primary d-block w-100 mt-3"
              type="submit"
              name="submit"
              [disabled]="submitLoading"
            >
              @if (parsed.kind === "passwordReset") {
              {{ "general.continue" | translate }}
              } @else {
              {{ "general.logIn" | translate }}
              }
            </button>
          </div>
        </form>
        }
      </div>
    </div>
  </div>
</div>
